import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import classnames from "classnames";

import Navigation from "./components/Navigation";
import DiamondChallenge from "./components/challenges/DiamondChallenge";
import ArrowChallenge from "./components/challenges/ArrowChallenge";
import StairChallenge from "./components/challenges/StairChallenge";
import SigmaChallenge from "./components/challenges/SigmaChallenge";

import About from "./pages/About";
import Projects from "./pages/Projects";
import Resume from "./pages/Resume";
import Contact from "./pages/Contact";

import {
  shouldShowNav,
  shouldShowPad,
  activePuzzle,
  unlockedContent,
  shouldShowBypass,
  isMenuOpen
} from "./selectors/ui";
import * as appActions from "./actions";
import * as uiActions from "./actions/ui";

import "./styles/app.css";

const navBackgroundOpacityThreshold = 150;
const navBackgroundOpacityUpperLimit = 0.92;

const challengeComponents = {
  diamond: DiamondChallenge,
  arrow: ArrowChallenge,
  stair: StairChallenge,
  sigma: SigmaChallenge
};

const contentComponents = {
  About: About,
  Projects: Projects,
  Contact: Contact,
  Resume: Resume
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navBackgroundOpacity: 0,
      isMenuOpen: false
    };
    this.bottomBarRef = React.createRef();
  }
  componentDidMount() {
    this.startScrollListener();
  }
  updateBottomBarHeight = scroll_pos => {
    if (this.props.match.url === "/") return;
    let navBackgroundOpacity =
      scroll_pos >= navBackgroundOpacityThreshold
        ? navBackgroundOpacityUpperLimit
        : (scroll_pos / navBackgroundOpacityThreshold) *
          navBackgroundOpacityUpperLimit;
    this.setState({ navBackgroundOpacity });
  };
  startScrollListener = () => {
    var last_known_scroll_position = 0;
    var ticking = false;

    window.addEventListener("scroll", e => {
      last_known_scroll_position = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.updateBottomBarHeight(last_known_scroll_position);
          ticking = false;
        });

        ticking = true;
      }
    });
  };

  makeUnlockedContent = location => {
    return (
      <Switch location={location}>
        {this.props.unlockedContent.map(item => {
          const Component = contentComponents[item.title];
          return (
            <Route
              key={item.title}
              path={item.path}
              render={props => (
                <Component style={{ position: "absolute" }} {...props} />
              )}
            />
          );
        })}
      </Switch>
    );
  };
  render() {
    const ChallengeComponent = challengeComponents[this.props.activePuzzle];
    return (
      <div className={classnames("App", this.props.isMenuOpen && "menu-open")}>
        <Route exact path="/" render={_ => <Redirect to="/about" />} />
        <Navigation
          onToggleMenu={this.props.uiActions.toggleMenu}
          backgroundOpacity={this.state.navBackgroundOpacity}
          shouldShow={this.props.shouldShowNav}
          isMenuOpen={this.props.isMenuOpen}
        />
        {this.makeUnlockedContent(this.props.location)}

        <div className="background">
          <ChallengeComponent
            shouldShowBypass={this.props.shouldShowPad}
            onSkipPuzzles={this.props.actions.skipPuzzles}
            shouldShowPad={this.props.shouldShowPad}
            onFoundRune={this.props.actions.puzzleSolved}
          />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    shouldShowPad: shouldShowPad(state),
    shouldShowNav: shouldShowNav(state),
    activePuzzle: activePuzzle(state),
    unlockedContent: unlockedContent(state),
    shouldShowBypass: shouldShowBypass(state),
    isMenuOpen: isMenuOpen(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(appActions, dispatch),
    uiActions: bindActionCreators(uiActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js